import { render, staticRenderFns } from "./AppVehicleHeader.vue?vue&type=template&id=5a8a34a4&scoped=true&"
import script from "./AppVehicleHeader.vue?vue&type=script&lang=ts&"
export * from "./AppVehicleHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AppVehicleHeader.vue?vue&type=style&index=0&id=5a8a34a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a34a4",
  null
  
)

export default component.exports